import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import InputBase from '@mui/material/InputBase';
import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';
import { Colors } from '../../theme';

export const Heading = styled('header')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 6,
  textAlign: 'left',
}));

export const Title = styled(Typography)(() => ({
  color: Colors.WHITE,
  fontSize: '1.6rem',
  fontWeight: 700,
  lineHeight: 1.2,
}));

export const SubTitle = styled(Typography)(() => ({
  color: Colors.TEXT_ON_DARK_MUTED,
  fontSize: '0.95rem',
  lineHeight: 1.5,
}));

export const Form = styled('form')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
}));

export const ModeToggle = styled('div')(() => ({
  display: 'flex',
  gap: 4,
  padding: 4,
  borderRadius: 12,
  background: Colors.INPUT_ON_DARK,
}));

export const ModeTab = styled('button', {
  shouldForwardProp: (prop) => prop !== 'active',
})(({ active }) => ({
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 6,
  minHeight: 40,
  border: 'none',
  borderRadius: 9,
  cursor: 'pointer',
  fontFamily: 'inherit',
  fontSize: '0.9rem',
  fontWeight: 600,
  transition: 'background-color 160ms ease-out, color 160ms ease-out',
  background: active ? Colors.GREEN_BACKGROUND : Colors.TRANSPARENT,
  color: active ? Colors.BG_START : Colors.TEXT_ON_DARK_MUTED,
  '@media (hover: hover)': {
    '&:hover': {
      color: active ? Colors.BG_START : Colors.WHITE,
    },
  },
  '&:focus-visible': {
    outline: `2px solid ${Colors.GREEN_BACKGROUND}`,
    outlineOffset: 2,
  },
}));

export const FieldLabel = styled('label')(() => ({
  display: 'block',
  textAlign: 'left',
  marginBottom: 8,
  color: Colors.TEXT_ON_DARK_MUTED,
  fontSize: '0.85rem',
  fontWeight: 600,
}));

export const InputRow = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  minHeight: 52,
  padding: '0 14px',
  borderRadius: 12,
  background: Colors.INPUT_ON_DARK,
  border: `1.5px solid ${Colors.BORDER_ON_DARK}`,
  transition: 'border-color 160ms ease-out, background-color 160ms ease-out',
  '&:focus-within': {
    borderColor: Colors.GREEN_BACKGROUND,
    background: Colors.INPUT_ON_DARK_FOCUS,
  },
}));

export const CountrySelect = styled(Select)(() => ({
  color: Colors.WHITE,
  fontSize: '1rem',
  '& .MuiSelect-select': {
    padding: '4px 24px 4px 0',
  },
  '& .MuiSelect-icon': {
    color: Colors.TEXT_ON_DARK_MUTED,
  },
}));

export const InputDivider = styled('span')(() => ({
  alignSelf: 'center',
  width: 1,
  height: 24,
  background: Colors.BORDER_ON_DARK,
}));

export const LoginInput = styled(InputBase)(() => ({
  flex: 1,
  color: Colors.WHITE,
  // 16px evita que iOS haga zoom al enfocar el campo.
  fontSize: '1rem',
  '& input': {
    padding: '12px 0',
    color: Colors.WHITE,
    '&::placeholder': {
      color: Colors.TEXT_ON_DARK_SUBTLE,
      opacity: 1,
    },
  },
}));

export const HelperText = styled(Typography)(() => ({
  marginTop: 8,
  textAlign: 'left',
  color: Colors.TEXT_ON_DARK_SUBTLE,
  fontSize: '0.8rem',
}));

export const ErrorText = styled(Typography)(() => ({
  color: Colors.ERROR_TEXT_LIGHT,
  fontSize: '0.9rem',
  lineHeight: 1.4,
  textAlign: 'left',
}));

export const ButtonApp = styled(Button)(() => ({
  minHeight: 48,
  borderRadius: 12,
  background: Colors.GREEN_BACKGROUND,
  color: Colors.BG_START,
  fontSize: '1rem',
  fontWeight: 700,
  textTransform: 'none',
  transition: 'transform 120ms ease-out, background-color 160ms ease-out',
  '@media (hover: hover)': {
    '&:hover': {
      background: Colors.GREEN_HOVER,
    },
  },
  '&:active': {
    transform: 'scale(0.98)',
  },
  '&.Mui-disabled': {
    background: Colors.INPUT_ON_DARK,
    color: Colors.TEXT_ON_DARK_SUBTLE,
  },
}));
